export const setupListaParkow = () => {
  // jesli currentPageId jest jednym z parkow lub jesli currentPageParentId jest jednym z parkow to zaznaczmy ten park i odznaczym pozostale
  // window.currentPageId
  // window.currentPageParentId
  let isSelected = false;
  const ids = [];
  const parkList = $(".park-list");
  const parkListLis = parkList.find("li");
  parkListLis.map((index, li) => {
    const id = parseInt($(li).data("page"), 10);
    ids.push(id);
    if (id === window.parkPageId || id === window.currentPageId || id === window.currentPageParentId) {
      isSelected = true;
      $(li).addClass("selected");
    }
  });
  if (isSelected) {
    parkList.addClass("is-selected");
  }
};